import { getAxiosInstance } from "../ApiConfig";

async function AllLiManagersData() {
    try {
        const response = await getAxiosInstance().get(`/LicenseManager/findAllLicenseManager`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FindLicenseManager() {
    try {
        const response = await getAxiosInstance().get(`/LicenseManager/findLicenseManager`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function UpdateManager(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/LicenseManager/updateLicenseManager/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function Login(payload) {
    try {
        const response = await getAxiosInstance().post(`/LicenseManager/login`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function SendEmailOtpForForgotPassword(email, payload) {
    try {
        const response = await getAxiosInstance().post(`/LicenseManager/sendEmailOtpForForgotPassword/${email}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ForgotPasswords(payload) {
    try {
        const response = await getAxiosInstance().post(`/LicenseManager/forgotPassword`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchManagerUserDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/LicenseManager/findLicenseManagementById/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    AllLiManagersData,
    ForgotPasswords,
    UpdateManager,
    FetchManagerUserDetails,
    FindLicenseManager,
    Login,
    SendEmailOtpForForgotPassword,
}